import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-novedades',
  templateUrl: './hero-novedades.component.html',
  styleUrls: ['./hero-novedades.component.scss']
})
export class HeroNovedadesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
